/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The recognized Country codes for SAP, as defined in XSD schema for 9.94 RdSAP.
 */
export type SapCountryCodesV0 = 'EAW' | 'SCT' | 'NIR' | 'JERSEY';

export const SapCountryCodesV0 = {
    Eaw: 'EAW' as SapCountryCodesV0,
    Sct: 'SCT' as SapCountryCodesV0,
    Nir: 'NIR' as SapCountryCodesV0,
    Jersey: 'JERSEY' as SapCountryCodesV0
};

